var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_9028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 8.03281H4C2.89333 8.03281 1.95 7.64281 1.17 6.86281C0.39 6.08281 0 5.13947 0 4.03281C0 2.92614 0.39 1.98281 1.17 1.20281C1.95 0.422806 2.89333 0.0328064 4 0.0328064H7.4V1.23281H4C3.22223 1.23281 2.56111 1.50457 2.01666 2.04811C1.47222 2.59163 1.2 3.25163 1.2 4.02811C1.2 4.80457 1.47222 5.46614 2.01666 6.01281C2.56111 6.55947 3.22223 6.83281 4 6.83281H7.4V8.03281ZM4.9 4.63281V3.43281H11.1V4.63281H4.9ZM8.6 8.03281V6.83281H12C12.7778 6.83281 13.4389 6.56104 13.9833 6.01751C14.5278 5.47399 14.8 4.81399 14.8 4.03751C14.8 3.26104 14.5278 2.59947 13.9833 2.05281C13.4389 1.50614 12.7778 1.23281 12 1.23281H8.6V0.0328064H12C13.1067 0.0328064 14.05 0.422806 14.83 1.20281C15.61 1.98281 16 2.92614 16 4.03281C16 5.13947 15.61 6.08281 14.83 6.86281C14.05 7.64281 13.1067 8.03281 12 8.03281H8.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_9028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    fill: "white",
    transform: "translate(0 0.0328064)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.62d1080908efe002fa44b43631db43d2.svg";
export { ForwardRef as ReactComponent };